/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Node_AnimeInputs */

const en_fw_node_anime = /** @type {(inputs: Fw_Node_AnimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anime`)
};

const zh_fw_node_anime = /** @type {(inputs: Fw_Node_AnimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`动画`)
};

/**
* | output |
* | --- |
* | "Anime" |
*
* @param {Fw_Node_AnimeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_node_anime = /** @type {((inputs?: Fw_Node_AnimeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Node_AnimeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_node_anime(inputs)
	return zh_fw_node_anime(inputs)
});
export { fw_node_anime as "fw.node.anime" }